// extracted by mini-css-extract-plugin
export var root = "footer-module--root--KpmE-";
export var wrapper = "footer-module--wrapper--iAZv8";
export var column = "footer-module--column--C2DAr";
export var colored = "footer-module--colored--tuw1c";
export var logo = "footer-module--logo--mrnDn";